// ##############################
// // // table head data and table body data for Tables view
// #############################

const thead = ["ลำดับที่", "ข้อมูลชำระประจำวันที่", "เงินที่ชำระผ่านกรุงไทย (บาท)",
  "จำนวนโครงการ", "เงินที่ชำระผ่านออมสิน (บาท)", "จำนวนโครงการ",
  "เงินที่ชำระผ่านธกส (บาท)", "จำนวนโครงการ", "ตัดรับชำระ"];
const tbody = [
  {
    data: ["1", "19 ธ.ค. 2561", "0.00", "0", "3,570.00", "1", "0.00", "0", ""]
  },
  {
    data: ["2", "18 ธ.ค. 2561", "8,560.00", "1", "0.00", "0", "0.00", "0", ""]
  },
  {
    data: ["3", "15 ธ.ค. 2561", "0.00", "0", "8,500.00", "1", "0.00", "0", ""]
  },
  {
    data: ["4", "14 ธ.ค. 2561", "5,590.00", "1", "0.00", "0", "0.00", "0", ""]
  },
  {
    data: ["5", "13 ธ.ค. 2561", "3,830.00", "2", "0.00", "0", "0.00", "0", ""]
  },
  {
    data: ["6", "12 ธ.ค. 2561", "8,560.00", "1", "8,560.00", "1", "0.00", "0", ""]
  },
  {
    data: ["7", "11 ธ.ค. 2561", "25,620.00", "4", "16,970.00", "2", "0.00", "0", ""]
  },
  {
    data: ["8", "10 ธ.ค. 2561", "8,560.00", "1", "8,560.00", "1", "0.00", "0", ""]
  },
  {
    data: ["9", "8 ธ.ค. 2561", "0.00", "0", "15,586.00", "3", "0.00", "0", ""]
  },
  {
    data: ["10", "7 ธ.ค. 2561", "81,166.00", "14", "28,555.85", "4", "8,560.00", "1", ""]
  },
  {
    data: ["11", "6 ธ.ค. 2561", "156,528.00", "21", "59,920.00", "7", "0.00", "0", ""]
  },
  {
    data: ["12", "5 ธ.ค. 2561", "357,340.00", "46", "43,280.00", "6", "0.00", "0", ""]
  },
  {
    data: ["13", "4 ธ.ค. 2561", "312,870.35", "41", "16,730.00", "2", "68,220.00", "0", ""]
  },
  {
    data: ["14", "3 ธ.ค. 2561", "141,068.00", "19", "8,560.00", "1", "0.00", "0", ""]
  },
  {
    data: ["15", "2 ธ.ค. 2561", "125,680.00", "3", "0.00", "0", "0.00", "0", ""]
  },
  {
    data: ["16", "1 ธ.ค. 2561", "11,330.00", "2", "0.00", "0", "0.00", "0", ""]
  }
];

// data for <thead> of table in TableList view
// data for <tbody> of table in TableList view
export { thead, tbody };
